import { render, staticRenderFns } from "./addAnnouncement.vue?vue&type=template&id=1871c658&scoped=true"
import script from "./addAnnouncement.vue?vue&type=script&lang=js"
export * from "./addAnnouncement.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./addAnnouncement.vue?vue&type=style&index=1&id=1871c658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1871c658",
  null
  
)

export default component.exports